module.exports = __webpack_public_path__ + "img/main-2.aa35b55d.jpg";